export default {
  getBannersHome(state) {
    return state.bannersHome || [];
  },
};
